// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JwtDecode = require("jwt-decode");
var Relude_Option = require("relude/src/Relude_Option.bs.js");

function decode(maybeJwt) {
  try {
    return Relude_Option.pure(JwtDecode(maybeJwt));
  }
  catch (exn){
    return ;
  }
}

function decodeHeader(maybeJwt) {
  try {
    return Relude_Option.pure(JwtDecode(maybeJwt, {"header": true}));
  }
  catch (exn){
    return ;
  }
}

exports.decode = decode;
exports.decodeHeader = decodeHeader;
/* jwt-decode Not a pure module */
